import { all, any, compose, equals, filter, includes, pluck, prop, propOr } from 'ramda';
import { createSelector } from 'reselect';

import { EMPTY_VALUES } from 'constants/general';
import { isUserLoginFormat } from 'utils';

import { NAME, raAnalysisTypes } from './constants';

const getRoot = prop(NAME);

export const getSort = createSelector(getRoot, prop('sort'));
export const getQuickFilterState = createSelector(getRoot, prop('quickFilter'));
export const getRaAnalysis = createSelector(getRoot, propOr(EMPTY_VALUES.ARRAY, 'raAnalysis'));
export const getCheckboxStatuses = createSelector(getRoot, propOr(EMPTY_VALUES.OBJECT, 'checkboxStatuses'));
export const getCheckAllCheckbox = createSelector(getRoot, propOr(false, 'checkAllCheckbox'));
export const getIsRaAnalysisCheckedById = createSelector(
	getCheckboxStatuses,
	(state, id) => id,
	(checkboxStatuses, id) => propOr(false, id)(checkboxStatuses),
);

export const getShownRAAnalysisIds = createSelector(getRaAnalysis, (raAnalysisRecords) => {
	// onboarding type record is not possible to select, therefore we dont care about it
	const recordsWithoutOnboardingType = raAnalysisRecords.filter(
		(record) => record.type !== raAnalysisTypes.ONBOARDING,
	);
	return pluck('id')(recordsWithoutOnboardingType);
});

export const getShownRaRecordsCheckedValues = createSelector(
	getShownRAAnalysisIds,
	getCheckboxStatuses,
	(shownRaRecordsIds, checkboxStatuses) => shownRaRecordsIds.map((id) => checkboxStatuses[id]),
);

export const getAreAllShownRaRecordsChecked = createSelector(getShownRaRecordsCheckedValues, all(equals(true)));
export const getIsAnyRaAnalysisSelected = createSelector(getShownRaRecordsCheckedValues, any(equals(true)));

export const getCheckedRaAnalysis = createSelector(
	getRaAnalysis,
	getCheckboxStatuses,
	(raAnalysis, checkboxStatuses) => {
		const isTrue = (item) => equals(true)(item);
		const onlyChecked = filter(isTrue, checkboxStatuses);
		const checkedIds = Object.keys(onlyChecked);
		return raAnalysis.filter((item) => includes(item.id, checkedIds));
	},
);

export const getUserSubordinateUsers = createSelector(
	getRoot,
	compose(
		filter(({ login }) => isUserLoginFormat(login)),
		propOr(EMPTY_VALUES.ARRAY, 'userSubordinates'),
	),
);
